// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1fO-5","alert":"SettungsInbox_alert__1reL2"};